import React from 'react';
import PropTypes from 'prop-types';
import Avatar from 'components/general/Avatar';
import { useNavigate } from 'react-router-dom';
import { IconEdit, IconTrash } from '@tabler/icons-react';
import { cookie } from 'utils/cookies';

const Table = ({ data, handleDeleteBtn = () => { } }) => {
  const navigate = useNavigate();
  const userRole = cookie.get('user-role');

  // ✅ Apply filtering based on user role
  const filteredData =
    userRole === 'engineer'
      ? data.filter((row) => row.role === 'contractor')
      : data;

  return (
    <div className="table-responsive">
      <table className="table premium-table table-vcenter text-nowrap align-middle mb-0">
        <thead>
          <tr>
            <th>User</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Reporting Manager</th>
            <th className="text-end" style={{ paddingRight: '1rem' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.length > 0 ? (
            filteredData.map((row) => (
              <tr key={row.id}>
                <td className="user_name">
                  <div className="d-flex align-items-center gap-2">
                    <Avatar
                      role={row?.role}
                      name={`${row?.name} ${row?.lastName ? row?.lastName : ''}`}
                    />
                    <span>
                      {`${row?.name} ${row?.lastName ? row?.lastName : ''}`}
                    </span>
                  </div>
                </td>
                <td>{row.email}</td>
                <td>{row.phone ?? '-'}</td>
                <td>
                  {row.reportingManager?.name
                    ? `${row.reportingManager?.name} ${row.reportingManager?.lastName || ''
                    }`
                    : '-'}
                </td>
                <td>
                  <div className="d-flex gap-2 all_btn justify-content-end align-items-center">
                    <div className="role_btn me-2 fw-bold text-capitalize" style={{ fontSize: '0.7rem', color: '#4b5563', padding: '2px 8px', backgroundColor: '#f3f4f6', borderRadius: '6px', border: '1px solid #e5e7eb', whiteSpace: 'nowrap' }}>{row.role}</div>
                    <div
                      className="edit_btn"
                      title="Edit User"
                      onClick={() => navigate('/usermanagement/edit/' + row.id)}
                    >
                      <IconEdit size={18} />
                    </div>
                    <div
                      className="delete_btn"
                      title="Delete User"
                      onClick={() => handleDeleteBtn(row.id)}
                    >
                      <IconTrash size={18} />
                    </div>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td className="user_name" colSpan="5">
                No records found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

Table.propTypes = {
  data: PropTypes.array,
  handleDeleteBtn: PropTypes.func,
};

export default Table;
